import {FC, useEffect} from 'react';
import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
import {useMediaQuery} from 'react-responsive';
import {useAppStore} from '@/stores';
import s from './index.module.scss';

const Hamburger: FC = () => {
  const {
    sidebarCollapsed,
    toggleSideBar,
    toggleMobileSidebar,
    setSideBarCollapse,
    setSideMobileSidebarOpen,
  } = useAppStore();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1200px)',
  });
  const isMobile = useMediaQuery({query: '(max-width:576px)'});

  useEffect(() => {
    if (!isMobile) {
      setSideMobileSidebarOpen(false);
      if (isDesktopOrLaptop) {
        setSideBarCollapse(false);
      } else {
        setSideBarCollapse(true);
      }
    } else {
      setSideMobileSidebarOpen(false);
      setSideBarCollapse(false);
    }
  }, [isDesktopOrLaptop, isMobile]);

  // toggle side menu
  const toggleSideMenu = () => {
    if (isMobile) {
      toggleMobileSidebar();
    } else {
      toggleSideBar();
    }
  };
  return (
    <button type='button' className={s.hamburger} onClick={toggleSideMenu}>
      {sidebarCollapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>}
    </button>
  );
};

export default Hamburger;
